import { Sparkles, ArrowRight } from 'lucide-react';

const SEO_PAGES = [
  { href: '/photobooth-tunisie', label: 'Photobooth en Tunisie' },
  { href: '/photographe-mariage-djerba', label: 'Photographe mariage Djerba' },
  { href: '/photographe-evenement-tunis', label: 'Photographe événement Tunis' },
];

const SERVICES = [
  'Photographe & vidéaste mariage',
  'Location photobooth',
  'Production vidéo corporate',
  'Shooting studio & packshot',
];

interface AboutStudioSectionProps {
  showLists?: boolean;
}

export function AboutStudioSection({ showLists = true }: AboutStudioSectionProps) {
  return (
    <section className="relative overflow-hidden border-y border-gray-100 bg-white py-24">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-32 top-0 h-96 w-96 rounded-full bg-primary-50 blur-3xl" />
        <div className="absolute -left-32 bottom-0 h-80 w-80 rounded-full bg-indigo-50 blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className={`grid items-start gap-12 ${showLists ? 'lg:grid-cols-2 lg:gap-16' : 'max-w-4xl mx-auto'}`}>
          <div>
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary-500/10 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.25em] text-primary-600">
              <Sparkles className="h-3.5 w-3.5" />
              Studio depuis 1988
            </span>
            <h2 className="text-3xl font-black tracking-tighter text-gray-950 md:text-4xl">
              Studio créatif &amp; production événementielle
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-gray-600">
              <strong>Lbenna Prod</strong> réunit sous un même toit le reportage mariage, la vidéo corporate,
              le photobooth et la production audiovisuelle premium en Tunisie.
            </p>

            <div className="mt-6 space-y-4 text-base leading-relaxed text-gray-600">
              <p>
                Depuis 1988, nous accompagnons couples, entreprises et wedding planners avec une approche artisanale :
                préparation rigoureuse, matériel 4K et drone, retouche exigeante et production de haute précision pour des
                souvenirs qui durent.
              </p>
              <p>
                Notre force : une maîtrise complète de la chaîne de production audiovisuelle. Chaque projet bénéficie
                d&apos;une post-production exigeante, garantissant un rendu cinématographique et intemporel.
              </p>
            </div>
          </div>

          {showLists && (
            <div className="space-y-6">
              <div className="rounded-[2rem] border border-gray-100 bg-gray-50 p-6 md:p-8">
                <h3 className="mb-4 text-sm font-black uppercase tracking-[0.2em] text-gray-400">Nos prestations</h3>
                <ul className="space-y-3">
                  {SERVICES.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm font-semibold text-gray-800">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary-500" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-[2rem] border border-primary-100 bg-primary-50/50 p-6 md:p-8">
                <h3 className="mb-4 text-sm font-black uppercase tracking-[0.2em] text-primary-600">Pages services</h3>
                <div className="flex flex-wrap gap-2">
                  {SEO_PAGES.map((page) => (
                    <div
                      key={page.href}
                      className="flex items-center gap-2 rounded-full border border-gray-100 bg-gray-50/50 px-4 py-2 text-xs font-bold text-gray-400 cursor-not-allowed"
                    >
                      {page.label}
                      <span className="text-[9px] bg-amber-100 text-amber-600 px-1.5 py-0.5 rounded-full uppercase tracking-tighter">Bientôt</span>
                    </div>
                  ))}
                </div>
                <div
                  className="mt-5 inline-flex items-center gap-2 text-sm font-black text-gray-400 cursor-not-allowed"
                >
                  Demander un devis gratuit
                  <span className="text-[10px] bg-amber-100 text-amber-600 px-2 py-0.5 rounded-full uppercase">Bientôt</span>
                  <ArrowRight className="h-4 w-4" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
